import { createSelector } from 'reselect';
import UserStore from '../../../../stores/UserStore';
import Money from '../../../../utils/Money/Money';
import { getCurrencyItemInterval } from '../../../../helpers/common';
import store from '../../../../stores/redux';

const balance = (state) => state.user?.publisher?.account?.balance || {};
const currencyRatios = (state) => state.currencyRatios.list;
const serverStore = (state) => state.serverStorage.store;

const getSupportedCurrencies = () => {
    let currencies = store.getState().currency.list;
    let supportedCurrencies = [];

    currencies.map((element) => {
        if (element.supported) {
            supportedCurrencies.push(element.title);
        }
    });

    return supportedCurrencies;
};

const getSelectedCurrencies = () => {
    let storeServerStorage = store.getState().serverStorage.store;
    let storeCurrencies = storeServerStorage.dataTable.currencies;
    let selectedCurrencies = [];

    if (storeCurrencies && storeCurrencies.length) {
        storeCurrencies.map((element) => {
            if (element.visible) {
                selectedCurrencies.push(element.keyTitle);
            }
        });
    }

    return selectedCurrencies;
};

export const getSelectOptions = createSelector(
    currencyRatios,
    balance,
    (currencyRatios = [], balance) => {
        let list = [];

        if (currencyRatios.length) {
            Object.keys(currencyRatios[0].rates).map((key) => {
                list.push({
                    title: key,
                    value: key
                });
            });

            // we establish the balance currency
            list.sort((a, b) => {
                if (a.value === balance.currency) return -1;
                if (b.value === balance.currency) return 1;

                return 0;
            });
        }

        return list;
    }
);

export const getHeaderNames = (currencyRatios = [], currency) => {
    const currencyNames = UserStore.getTranslation().currencyPage.table;
    let headerNames = [
        [{
            value: currencyNames.date,
            colspan: '1'
        }],
        [{
            value: currencyNames.interval
        }]
    ];
    let selectedCurrencies = getSelectedCurrencies();
    let supportedCurrencies = getSupportedCurrencies();

    if (currencyRatios.length) {
        supportedCurrencies.map((key) => {
            if (currencyRatios[0].rates[currency][key] && currency !== key) {
                headerNames[0].push({value: `${currency}/${key}`, colspan: '2'});

                headerNames[1].push({value: currencyNames.inner});
                headerNames[1].push({value: currencyNames.external});
            }
        });

        selectedCurrencies.map((key) => {
            if (currencyRatios[0].rates[currency][key]) {
                headerNames[0].push({value: `${currency}/${key}`, colspan: '2'});

                headerNames[1].push({value: currencyNames.inner});
                headerNames[1].push({value: currencyNames.external});
            }
        });
    }

    return headerNames;
};


export const getCurrencyRatios = (currencyRatios = [], currencies = [], currency) => {
    const currencyNames = UserStore.getTranslation().currencyPage.table;
    let list = [];
    let selectedCurrencies = getSelectedCurrencies();
    let supportedCurrencies = getSupportedCurrencies();

    currencyRatios.map((item) => {
        let itemData = {};

        itemData.interval = getCurrencyItemInterval(item.created_at, item.expired_at, {
            from: `${currencyNames.from} `,
            to: ` ${currencyNames.to} `
        });

        supportedCurrencies.map((key) => {
            if (item.rates[currency][key] && currency !== key) {
                let rates = item.rates[currency][key];

                itemData[currency + key + 'вн'] = Money.toFixedRatio(rates.ask, key, true);
                itemData[currency + key + 'внешн'] = Money.toFixedRatio(rates.bid, key, true);
            }
        });

        selectedCurrencies.map((key) => {
            if (item.rates[currency][key]) {
                let rates = item.rates[currency][key];
                itemData[currency + key + 'вн'] = Money.toFixedRatio(rates.ask, key, true);
                itemData[currency + key + 'внешн'] = Money.toFixedRatio(rates.bid, key, true);
            }
        });

        list.push(itemData);
    });

    return list;
};

export const getCurrenciesList = createSelector(
    serverStore,
    (serverStore) => {
        return store.getState().serverStorage.store.dataTable['currencies'];
    }
);
